import React from "react";
import "./About.css";
import cover from "./../assets/building-cover.jpeg";

const About = () => {
  return (
    <div className="about-container">
      <div className="hl-0"></div>
      <div className="hl-1"></div>
      <div className="hl-2"></div>
      <div className="hl-3"></div>
      <div className="about-header">
        <span className="about-mobile"> ABOUT &nbsp; </span>
        <span style={{ color: "#c5a47e" }}>
          CHAWLA STRUCTURAL DESIGN ENGINEERS & CONSULTANT
        </span>
      </div>
      <div className="about-wrapper">
        <div className="info-1">
          <div className="info-1-header">we turn dreams into realities</div>
          <div className="info-1-para" style={{ textAlign: "justify" }}>
            Our vision towards projects is to create safe,
            innovative, efficient, and collaborative structures that meet the
            needs of our clients while also benefiting society as a whole.
          </div>
        </div>
        <div className="info-2">
          <div className="info-2-header">our specialization:</div>
          <div className="icons">
            <img
              src="https://7seven-miles.com/wp/go-arch/go-arch-light/wp-content/uploads/2011/05/icon-architecture.png"
              alt=""
            />
            <h4>HYDRAULIC STRUCTURES</h4>
          </div>
          <div className="icons">
            <img
              src="https://7seven-miles.com/wp/go-arch/go-arch-light/wp-content/uploads/2011/05/icon-interiors.png"
              alt=""
            />
            <h4>MULTI STOREY BUILDINGS</h4>
          </div>
          <div className="icons">
            <img
              src="https://7seven-miles.com/wp/go-arch/go-arch-light/wp-content/uploads/2011/05/icon-planing.png"
              alt=""
            />
            <h4>CONCRETE & BITUMINOUS ROADS</h4>
          </div>
        </div>
        <div className="info-3">
          <img src={cover} alt="" />
        </div>
      </div>
      <div className="about-projects">
        OUR &nbsp;<span style={{ color: "#c5a47e" }}>PROJECTS</span>
      </div>
    </div>
  );
};

export default About;
